const API_PATH = {
  SEND_OTP: "/policy/prosure/customer/sendOTP",
  RESEND_OTP: "/policy/prosure/customer/resendOTP",
  VERIFY_OTP: "/policy/prosure/customer/authenticateOTP",
  CUSTOMER_DETAIL: "/policy/prosure/customer/homepage",
  SUPPORT: '/lead/contactUs',
  LIVELONG: '/third-party/liveLong/updateAndSSO',
  SAVE_USER: 'policy/prosure/partner/saveUser',
  INITIATED_PAYMENT: "/third-party/coversure/payU/initiatePayment",
  PAYMENT_STATUS: "/third-party/coversure/payU/checkTransactionStatus/",
};
 
export default API_PATH;
